import { render } from "./TieredChallengeWeeklyChart.vue?vue&type=template&id=4e8df6eb"
import script from "./TieredChallengeWeeklyChart.vue?vue&type=script&lang=js"
export * from "./TieredChallengeWeeklyChart.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./TieredChallengeWeeklyChart.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_3bc203ad%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fchallenge%2Ftiered%2FTieredChallengeWeeklyChart.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__